import React, { Component } from 'react';
import Camera from './Camera';

class CameraField extends Component {
  constructor(props){
    super(props)
    this.state = {
        showCamera: false
    }
    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleShowCamera = this.handleShowCamera.bind(this)
  }

  handleOnChange(value){
    this.handleShowCamera()
    this.props.onChange(value)
  }

  handleShowCamera(){
    const {showCamera} = {...this.state};
    this.setState({...this.state, showCamera: !showCamera});
  }

  render() {
    const cameraElement = this.state.showCamera ? (<Camera onChange={this.handleOnChange} onReturn={this.handleShowCamera}/>) : (<button className='btn btn-default' onClick={this.handleShowCamera}><span className="glyphicon glyphicon-camera" aria-hidden="true"></span></button>);
    return cameraElement;
  }
}
module.exports = CameraField


/** WEBPACK FOOTER **
 ** ./src/components/CameraField.js
 **/